module.exports = __webpack_public_path__ + "static/media/cae.db28b3b3.png";